import { sec } from './units.ts';

/**
 * Ser Edda, the Sworn (paladin, holy — a cold white light, never gold): she swore not to let the chapel fall, and the
 * chapel fell (docs/ANTIHEROES.md, "Los siete que faltan"). Her oath guards the nightmares around her; strike her, not
 * her guard. Hurts like every Unsleeping: at least `maxHpBp` of the hero's own health.
 */
export const EDDA = {
  /** Her blow (a mace of black glass), at least `blowMaxHpBp` of the struck hero's health. */
  blowMaxHpBp: 1000,
  /** The oath (passive): other nightmares within `radius` of her take `takenBp` of every blow; a hero's blow on them comes back on it as light, `backBp` of the blow. */
  oath: { radius: 3000, takenBp: 5000, backBp: 2500 },
  /** Judgement: cold light on the farthest hero between `minRange` and `range`; struck and stunned `stun`. */
  judgement: { every: sec(7), range: 6500, minRange: 1800, damage: 70, maxHpBp: 1800, stun: sec(1) },
  /** Aegis: every other nightmare within `radius` takes a ward of `wardBp` of its life, and nothing stops her for `unstoppable`. */
  aegis: { every: sec(15), radius: 3500, wardBp: 3500, unstoppable: sec(4) },
  /**
   * The Fallen Chapel (ultimate): a column of white light `radius` wide on the closest knot of heroes within `range`.
   * Heroes in it take `damage` (at least `maxHpBp` of their health) and are thrown `knock` from its middle; the
   * nightmares in it mend `healBp` of their life.
   */
  pillar: { range: 7000, radius: 2200, damage: 220, maxHpBp: 4500, knock: 1400, healBp: 4000 },
  /** Oath broken (at 33 %, once a fight): untouchable for `ticks`, kneeling, mending `healBp` of her life over it. */
  broken: { ticks: sec(4), healBp: 2500 },
};
